const Section6 = () => {
  return (
    <section
      className="relative w-full bg-cover bg-center py-16 px-4"
      style={{
        backgroundImage: "url('/assets/mbg-banner.webp')", 
      }}
    >
      <div className="absolute inset-0 bg-black bg-opacity-70"></div>

      <div className="relative mx-auto text-center text-white">
        <h2 className="text-3xl md:text-4xl font-bold capitalize">
          How We Did It
        </h2>
        <div className="w-48 h-2 bg-white mx-auto my-4"></div>
        <p className="text-sm md:text-base  mx-auto">
          Mean3 is proud to reveal the Digital Execution process of Pakistan's
          biggest movie of 2023, MoneyBack Guarantee. Take a look on how we at
          Mean3 pulled it off.
        </p>

        <div className="mt-6 w-full flex justify-center">
          <iframe
            className="w-full md:w-4/5 h-64 md:h-96 xl:h-[90vh] rounded-lg shadow-lg"
            src="https://www.youtube.com/embed/GDmxG_w5gDM" 
            title="YouTube video"
            frameBorder="0"
            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
            allowFullScreen
          ></iframe>
        </div>
      </div>
    </section>
  );
};

export default Section6;

